module.exports = __webpack_public_path__ + "img/img_book_bg.e98bb1a2.jpg";